import { faTimes } from '@fortawesome/pro-regular-svg-icons'
import { ActionIcon, Flex, Title } from '@mantine/core'
import { useRouter } from 'next/router'

import { useQueryGetAllBookingProducts } from '@flecto/core/saas'
import { useTranslation } from '@flecto/translations'
import { type CoreBooking } from '@flecto/types'
import { BadgeBookingStatus, Icon } from '@flecto/ui'

import { HeaderBookingActionsNext } from '../..'

type HeaderBookingProps = {
  booking?: CoreBooking
}

export function HeaderBookingNext({ booking }: HeaderBookingProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'booking' })
  const router = useRouter()

  const { data: bookingProducts } = useQueryGetAllBookingProducts({
    bookingId: booking?.internal_id,
  })

  const bookingId = booking?.internal_id

  return (
    <Flex gap='md' justify='space-between' wrap='wrap' w='100%' align='center'>
      <ActionIcon
        onClick={() => {
          router.push('/bookings')
        }}
        variant='light'
        color='gray'
      >
        <Icon icon={faTimes} size='lg' />
      </ActionIcon>
      <Title order={3} data-testid='header-title'>
        {bookingId && booking
          ? `${t('create_booking_title')} #${bookingId}`
          : t('page_create_title')}
      </Title>
      <BadgeBookingStatus booking={booking} mt='xs' />
      <Flex flex={1} justify='flex-end'>
        <HeaderBookingActionsNext
          booking={booking}
          bookingProducts={bookingProducts}
        />
      </Flex>
    </Flex>
  )
}
